import type { ContentResponseModel, InitializationResponseModel } from '@api';
import { FetchError } from 'ofetch';

export function useApi(): {
  getSetup: () => Promise<InitializationResponseModel>;
  getContent: (path: string, isEditMode: boolean) => Promise<ContentResponseModel | null>;
} {
  const headers = useRequestHeaders(['cookie']);

  const getSetup = async (): Promise<InitializationResponseModel> => {
    return $fetch<InitializationResponseModel>('/api/setup', { headers });
  };

  const getContent = async (
    path: string,
    isEditMode: boolean
  ): Promise<ContentResponseModel | null> => {
    const contentPath = isEditMode ? splitCmsUrlToContentPath(path) : path;
    return $fetch<ContentResponseModel | null>(
      `/api/content?path=${contentPath}${isEditMode ? '&isEditMode=true' : ''}`,
      {
        headers,
      }
    ).catch((error: unknown) => {
      if (error instanceof FetchError) {
        return error.data.data as ContentResponseModel;
      }

      return null;
    });
  };

  return {
    getSetup,
    getContent,
  };
}
